import { Routes } from '@angular/router';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const profileRoutes: Routes = [
  {
    title: 'pagesTitles.changePassword',
    path: APP_ROUTES.CHANGE_PASSWORD,
    loadComponent: () => import('./pages/change-password').then((m) => m.ChangePassword),
  },
];
